import { render, staticRenderFns } from "./MessageCircleQuestionMarkIcon.vue?vue&type=template&id=04e46347"
import script from "./MessageCircleQuestionMarkIcon.vue?vue&type=script&lang=js"
export * from "./MessageCircleQuestionMarkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports